import { widgetChartOptions } from "utils/options";
import styled from "styled-components";
import SelectComponent from "components/atoms/select/SelectComponent";

export type WidgetChart = "graph" | "list";
interface Props {
  value: string;
  defaultValue?: any;
  onChange: (value: WidgetChart) => void;
}

export default function TypeSelects(props: Props): JSX.Element {
  const onChange = (value: string) => {
    props.onChange && props.onChange(value as WidgetChart);
  };

  return (
    <Select>
      <SelectComponent
        options={widgetChartOptions}
        onChange={onChange}
        value={widgetChartOptions.find((op) => op.value === props.value)}
        data-testid="dashboard-dashboard-table-selects-change"
      />
    </Select>
  );
}

const Select = styled.div`
  width: 80px;
`;
